import React, { useCallback } from "react";

import Menu from "antd/es/menu";
import { useIntl } from "react-intl";

import { MapFilterEntityType } from "@mapmycustomers/shared/types/entity";

import getMapEntityTypeDisplayName from "../utils/getMapEntityTypeDisplayName";

import styles from "./AvailableEntityTypesMenu.module.scss";

interface Props {
  items: MapFilterEntityType[];
  onSelect?: (entityType: MapFilterEntityType) => void;
}

const AvailableEntityTypesMenu: React.FC<Props> = ({ items, onSelect }) => {
  const intl = useIntl();

  const handleClick = useCallback(({ key }) => onSelect?.(key), [onSelect]);

  return (
    <Menu className={styles.menu} onClick={handleClick}>
      {items.map((entityType) => (
        <Menu.Item data-menu-item-id={entityType} key={entityType}>
          {getMapEntityTypeDisplayName(intl, entityType)}
        </Menu.Item>
      ))}
    </Menu>
  );
};

export default AvailableEntityTypesMenu;
